


















































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import GlobalMixins from '../mixins'
import { bus, zirafHTTP } from '../main'

@Component
export default class NewClient extends GlobalMixins {
	client = {
		name: '',
		email: '',
		phone: '',
		position: '',
		location: '',
		contact: '',
		active: true
	}
	clientErrors = {
		name: false,
		email: false,
		phone: false,
		position: false,
		location: false,
		contact: false
	}
	clientErrorMessages = {
		name: '',
		email: '',
		phone: '',
		position: '',
		location: '',
		contact: ''
	}
	canCreateNewClient: boolean = false

	@Watch('client', {deep: true})
	onClientChange(): void {
		this.clientErrors = {
			name: false,
			email: false,
			phone: false,
			position: false,
			location: false,
			contact: false
		}
		this.clientErrorMessages = {
			name: '',
			email: '',
			phone: '',
			position: '',
			location: '',
			contact: ''
		}
		this.canCreateNewClient = false

		if (!this.client.name) {
			this.clientErrors.name = true
			this.clientErrorMessages.name = 'De naam kan niet leeg zijn'
		}
		if (!this.client.position) {
			this.clientErrors.position = true
			this.clientErrorMessages.position = 'De functie kan niet leeg zijn'
		}
		if (!this.client.location) {
			this.clientErrors.location = true
			this.clientErrorMessages.location = 'De locatie kan niet leeg zijn'
		}
		if (!this.client.contact) {
			this.clientErrors.contact = true
			this.clientErrorMessages.contact = 'De contactpersoon kan niet leeg zijn'
		}
		if (!this.client.email || (this.client.email && !this.validateEmail(this.client.email))) {
			this.clientErrors.email = true
			this.clientErrorMessages.email = !this.client.email ? 'E-mail adres mag niet leeg zijn' : 'E-mail adres is niet geldig'
		}
		if (!this.client.phone) {
			this.clientErrors.phone = true
			this.clientErrorMessages.phone = 'Het telefoonnummer kan niet leeg zijn'
		} else if (this.phoneContainsLetters(this.client.phone)) {
			this.clientErrors.phone = true
			this.clientErrorMessages.phone = 'Het telefoonnummer mag geen letters bevatten'
		}

		if (!this.clientErrors.name && !this.clientErrors.position && !this.clientErrors.location && !this.clientErrors.contact && !this.clientErrors.email && !this.clientErrors.phone) {
			this.canCreateNewClient = true
		}
	}

	createNewClient(): void {
		zirafHTTP.post('clients', {
			name: this.client.name,
			email: this.client.email,
			phone: this.client.phone,
			position: this.client.position,
			location: this.client.location,
			contact: this.client.contact,
			active: true
		})
			.then(response => {
				this.$router.replace({ name: 'client', params: { id: response.data.id } })
			})
			.catch(error => {
				console.error(error.response.data)
				
				this.checkIfSessionExpired(error.response.data.errorCode, () => {
					if (error.response.data.errorCode === 10351) {
						bus.$emit('pushNotification', {
							error: true,
							message: this.returnErrorByCode(10351)
						})
					} else {
						bus.$emit('pushNotification', {
							error: true,
							message: 'De klant kon niet worden toegevoegd'
						})
					}
				})
			})
	}
	
	mounted() {
		Vue.nextTick(() => {
			bus.$emit('initCompleteContent')
		})
	}
}
